
import {authTokenStorage} from './authTokenStorage';
import {AuthToken} from "../../types/user/authData";

interface UserCredentials {
    userId: number,
    groupId: number,
    profileId: number,
    companyId: number,
    userWorkFlowId: number | null,
    daysForPasswordExpiration: number,
    fullName: string,
    defaultLanguage: string,
    isBankGroup: boolean,
    isInternalGroup: boolean
};

class UserStorage {
    keyStorage = "onboardingUserStorage";

    public save(
        userId: number,
        groupId: number,
        profileId: number,
        userWorkFlowId: number | null,
        daysForPasswordExpiration: number,
        fullName: string,
        defaultLanguage: string,
        isBankGroup: boolean,
        isInternalGroup: boolean,
        authToken: AuthToken
    )
    {
        const userCredentials: UserCredentials =
            {
                userId: userId,
                groupId: groupId,
                profileId: profileId,
                companyId: 1,
                userWorkFlowId: userWorkFlowId,
                daysForPasswordExpiration: daysForPasswordExpiration,
                fullName: fullName,
                defaultLanguage: defaultLanguage,
                isBankGroup: isBankGroup,
                isInternalGroup: isInternalGroup
            }

        localStorage.setItem(this.keyStorage, JSON.stringify(userCredentials));

        authTokenStorage.save(authToken);
    }

    public get(): UserCredentials {
        return JSON.parse(
            localStorage.getItem(this.keyStorage) as string
        ) as UserCredentials
    }

    public removeFromStorage() {
        localStorage.removeItem(this.keyStorage);

        authTokenStorage.removeFromStorage();
    }

    public getUserId() { return this.get().userId; }

    public getGroupId() { return this.get().groupId; }

    public getProfileId() { return this.get()?.profileId; }

    public getCompanyId() { return this.get().companyId; }

    public getUserWorkflowId() { return this.get().userWorkFlowId; }

    public getDaysForPasswordExpiration() { return this.get().daysForPasswordExpiration; }

    public getFullName() { return this.get().fullName; }

    public getDefaultLanguage() { return this.get().defaultLanguage; }
    public hasToken() { return authTokenStorage.get() !== null; }
    
    public getToken = () => { return authTokenStorage.get() }

    public isAdministrator() : boolean {
        return (this.get()?.profileId === 5)
    }
}

export const userStorage = new UserStorage();